import { render, staticRenderFns } from "./SalaryMonth.vue?vue&type=template&id=aed04bf6&"
import script from "./SalaryMonth.vue?vue&type=script&lang=js&"
export * from "./SalaryMonth.vue?vue&type=script&lang=js&"
import style0 from "./SalaryMonth.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports